import { ChoiceQuestion, MultiChoiceQuestion } from "@cur8/questionnaire";
import { Trans } from "./trans";

export enum SkinConditionsEnum {
  Yes = "Yes",
  No = "No",
}

export enum SkinConditionsTypeEnum {
  Acne = "Acne",
  Eczema = "Eczema",
  Psoriasis = "Psoriasis",
  Rosacea = "Rosacea",
  SkinCancer = "Skin cancer",
  SomethingElse = "Something else",
}

export enum SkinCancerTypeEnum {
  ActinicKeratosis = "Actinic Keratosis",
  BCC = "BCC",
  Melanoma = "Melanoma",
  SCC = "SCC",
  NotSure = "Not sure",
}

export const SkinConditions = new ChoiceQuestion(
  <Trans.SkinConditions.Question />,
  [
    [<Trans.SkinConditions.No />, SkinConditionsEnum.No],
    [<Trans.SkinConditions.Yes />, SkinConditionsEnum.Yes],
  ]
);

export const SkinConditionsType = new MultiChoiceQuestion(
  <Trans.SkinConditions.TypeQuestion />,
  [
    [
      {
        label: <Trans.SkinConditions.Acne />,
        description: <Trans.SkinConditions.AcneDescription />,
      },
      SkinConditionsTypeEnum.Acne,
    ],
    [
      {
        label: <Trans.SkinConditions.Eczema />,
        description: <Trans.SkinConditions.EczemaDescription />,
      },
      SkinConditionsTypeEnum.Eczema,
    ],
    [
      {
        label: <Trans.SkinConditions.Psoriasis />,
        description: <Trans.SkinConditions.PsoriasisDescription />,
      },
      SkinConditionsTypeEnum.Psoriasis,
    ],
    [
      {
        label: <Trans.SkinConditions.Rosacea />,
        description: <Trans.SkinConditions.RosaceaDescription />,
      },
      SkinConditionsTypeEnum.Rosacea,
    ],
    [
      {
        label: <Trans.SkinConditions.SkinCancer />,
        description: <Trans.SkinConditions.SkinCancerDescription />,
      },
      SkinConditionsTypeEnum.SkinCancer,
    ],
    [
      { label: <Trans.SkinConditions.SomethingElse />, description: undefined },
      SkinConditionsTypeEnum.SomethingElse,
    ],
  ]
);

export const SkinConditionsSkinCancerType = new ChoiceQuestion(
  <Trans.SkinConditions.SkinCancerQuestion />,
  [
    [
      {
        label: <Trans.SkinConditions.ActinicKeratosis />,
        description: <Trans.SkinConditions.ActinicKeratosisDescription />,
      },
      SkinCancerTypeEnum.ActinicKeratosis,
    ],
    [
      {
        label: <Trans.SkinConditions.BCC />,
        description: <Trans.SkinConditions.BCCDescription />,
      },
      SkinCancerTypeEnum.BCC,
    ],
    [
      {
        label: <Trans.SkinConditions.Melanoma />,
        description: <Trans.SkinConditions.MelanomaDescription />,
      },
      SkinCancerTypeEnum.Melanoma,
    ],
    [
      {
        label: <Trans.SkinConditions.SCC />,
        description: <Trans.SkinConditions.SCCDescription />,
      },
      SkinCancerTypeEnum.SCC,
    ],
    [
      { label: <Trans.SkinConditions.NotSure />, description: undefined },
      SkinCancerTypeEnum.NotSure,
    ],
  ]
);
